const PENDING_JOIN_CODE_KEY = 'pendingJoinClassCode';

/** Mirrors the `claimedConversationId` stash-across-login pattern used for guest chat claiming. */
export function stashPendingJoinCode(code: string): void {
  try {
    localStorage.setItem(PENDING_JOIN_CODE_KEY, code);
  } catch (e) {}
}

export function peekPendingJoinCode(): string | null {
  try {
    return localStorage.getItem(PENDING_JOIN_CODE_KEY);
  } catch (e) {
    return null;
  }
}

export function consumePendingJoinCode(): string | null {
  try {
    const code = localStorage.getItem(PENDING_JOIN_CODE_KEY);
    if (code) localStorage.removeItem(PENDING_JOIN_CODE_KEY);
    return code;
  } catch (e) {
    return null;
  }
}
